
  <div class="filter-container">
    <form [formGroup]="byBranchForm">
      <div formArrayName="branches">
        <div
          class="sgc"
          *ngFor="let branchCtrl of branches.controls; let i = index"
        >
          <single-choice
            [formControl]="branchCtrl"
            (click)="setEditingIndex(i)"
            [completedUrl]="completionUrl"
            [topic]="'branches'"
            [editMode]="true"
            [ticketId]="fakeId"
            [icon]="'business'"
            (choiceEvent)="relaySingleChoice($event)"
            [labelOnDemand]="branchLabelerByService"
            [choiceObserver]="branchObserver"
          ></single-choice>
        </div>
      </div>

      <button type="button" class="add-branch-btn" (click)="addBranchField()">
        +
      </button>

      <not [filter]="byBranchFilter" (filterChanged)="onFilterChanged($event)">
      </not>

      <button class="apply-filter-btn" type="submit" (click)="apply()">
        Apply
      </button>
    </form>
  </div>

